import React from 'react';
import Modal, {
  ModalPrimaryButton,
  ModalSecondaryButton,
} from '../../../common/Modal';

const RemoveSubjectModal = ({
  show,
  subject,
  selectedSemester,
  loading,
  onConfirm,
  onCancel
}) => {
  if (!show || !subject) return null;

  return (
    <Modal
      isOpen
      onClose={onCancel}
      title="Remove subject?"
      icon="fa-exclamation-triangle"
      tone="danger"
      size="md"
      closeOnBackdrop={!loading}
      closeOnEscape={!loading}
      footer={
        <>
          <ModalSecondaryButton onClick={onCancel} disabled={loading}>
            Cancel
          </ModalSecondaryButton>
          <ModalPrimaryButton
            onClick={onConfirm}
            loading={loading}
            loadingText="Removing..."
            tone="danger"
          >
            <i className="fas fa-trash"></i>
            Remove subject
          </ModalPrimaryButton>
        </>
      }
    >
      <p className="text-sm text-slate-cloud">
        <strong className="text-grey-dusk">{subject.name}</strong> will be
        removed from your{" "}
        {selectedSemester?.name || "current semester"}.
      </p>

      <p className="mt-3 text-sm text-slate-cloud">
        Only the enrolment goes - your existing grades are preserved, and you
        can enrol in this subject again later.
      </p>
    </Modal>
  );
};

export default RemoveSubjectModal;
